import styled from 'styled-components'
import { minDeviceSizeForMediaQueries } from '@/utils/device-sizes'

export const BaseLayout = styled.div`
  @media ${minDeviceSizeForMediaQueries.tablet} {
    padding: 0rem;
  }
`
